import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdjustmentDetail } from 'src/app/acumatica/EntityServices/Adjustment.service';

@Component({
  selector: 'app-inv-adjustment-entry',
  templateUrl: './inv-adjustment-entry.component.html',
})
export class InvAdjustmentEntryDialog {
  adjustment: AdjustmentDetail;

  constructor(
    public dialogRef: MatDialogRef<InvAdjustmentEntryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      adjustment: AdjustmentDetail
    }
  ) {
    this.adjustment = data.adjustment;

    // if an adjustment quantity was already specified for the adjustment detial
    let adjustmentQty = Number.parseFloat((this.adjustment.AdjustQtyTo || 0).toString());
    if (!Number.isNaN(adjustmentQty) && adjustmentQty !== 0) {
      // reverse it to reflect the current system quantity
      this.adjustment.Quantity -= adjustmentQty;
    }
  }

  onConfirmClick() {
    // get the new adjustment quantity
    let newQty = Number.parseFloat((this.adjustment.AdjustQtyTo || 0).toString());

    // no adjustment qty entered
    if (Number.isNaN(newQty)) {
      this.dialogRef.close(undefined);
      return;
    }

    // current system quantity
    let currentQty = this.adjustment.Quantity;
    // calculate adjustment quantity (i.e. system==2, newQty==0.75, adjustment = -1.25)
    this.adjustment.Quantity = newQty - currentQty;

    this.dialogRef.close(this.adjustment);
  }

}
